let timeoutId: number | null = null;

export function debounce(callback: Function, delayInSeconds: number = 1000) {
  timeoutId && clearTimeout(timeoutId);

  timeoutId = window.setTimeout(async () => {
    await callback();
  }, delayInSeconds);
}
